<template>
  <div v-if="client_order_info" class="client_order_info">
    <div class="client_order_info__left">
      <div class="client_order_info__left__wrap" ref="content">
        <div class="main_info" ref="main_info">
          <div class="line row">
            <div class="col-md-1 col-sm-1">
              <fg-input v-model="client_order_info.id" type="text" :label="translate('client_order.id')"
                        :placeholder="translate('client_order.id')" :readonly="true" />
            </div>

            <div class="col-md-3 col-sm-3">
              <label>
                {{ translate('client_order.device_sku') }}
                <span
                    v-if="client_order_info.device_sku_test_config"
                    class="mdi mdi-information-outline pointer"
                    @click="show_test_config"
                />
              </label>
              <div @dblclick="copy_device_sku(client_order_info.device_sku_id)">
                <tree-select
                    v-model="client_order_info.device_sku_id"
                    :options="device_sku_list"
                    :placeholder="translate('client_order.device_sku')"
                    :clearable="false"
                    :searchable="true"
                    :disabled="!client_order_info.can_edit_device_sku"
                />
              </div>
            </div>

            <div class="col-md-1 col-sm-1">
              <div class="fg-wrapper">
                <fg-input v-model="device_count_status" type="text" :label="translate('client_order.count')"
                          :placeholder="translate('client_order.count')" :readonly="true" />
                <span
                    v-if="client_order_info.status < 60"
                    class="mdi mdi-pen minibtn edit"
                    @click="edit_device_count"
                />
              </div>
            </div>

            <div class="col-md-2 col-sm-2">
              <fg-input v-model="client_order_info.order_id" type="text" :label="translate('client_order.order_id')"
                        :placeholder="translate('client_order.order_id')" :readonly="true" />
            </div>

            <div class="col-md-2 col-sm-2">
              <fg-input v-model="client_order_info.date" type="text" :label="translate('client_order.date')"
                        :placeholder="translate('client_order.date')" :readonly="true" />
            </div>

            <div class="col-md-3 col-sm-3">
              <div class="form-group">
                <label>{{ translate('client_order.customer_user_name') }}</label>
                <tree-select
                    :value="Number(client_order_info.customer_user_id) || null"
                    @input="$set(client_order_info, 'customer_user_id', $event)"
                    :options="company_user_list"
                    :placeholder="translate('client_order.customer_user_name')"
                    :clearable="true"
                    :multiple="false"
                    :disabled="!!Number(client_order.customer_user_id)"
                />
              </div>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-4 col-sm-4">
              <fg-input v-model="client_order_info.order_form" type="text" :label="translate('client_order.order_form')"
                        :placeholder="translate('client_order.order_form')" />
            </div>

            <div class="col-md-4 col-sm-4">
              <fg-input v-model="client_order_info.name" type="text" :label="translate('client_order.name')"
                        :placeholder="translate('client_order.name')" />
            </div>

            <div class="col-md-4 col-sm-4">
              <router-link :to="'/client/' + client_order_info.client_id" class="link">
                <fg-input v-model="client_order_info.client_name" type="text" :label="translate('client_order.client_name')"
                          :placeholder="translate('client_order.client_name')" :readonly="true" />
              </router-link>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-3 col-sm-3">
              <fg-input v-model="client_order_info.utd_number" type="text" :label="translate('client_order.utd_number')"
                        :placeholder="translate('client_order.utd_number')" />
            </div>

            <div class="col-md-3 col-sm-3 form_select">
              <WrapDatePicker
                  type="date"
                  value_type="YYYY-MM-DD"
                  :placeholder="translate('client_order.utd_date')"
                  :label="translate('client_order.utd_date')"
                  v-model="client_order_info.utd_date"
                  :range="false"
                  :confirm="false"
              />
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="client_order_info.item_cost" type="text" :label="translate('client_order.item_cost')"
                        :placeholder="translate('client_order.item_cost')" />
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="client_order_info.cost" type="text" :label="translate('client_order.total_cost')"
                        :placeholder="translate('client_order.total_cost')" :readonly="true" />
            </div>
          </div>

          <div class="line row">
            <div class="col-md-3 col-sm-3">
              <div class="form-group">
                <label> {{ translate('client_order.type') }} </label>
                <tree-select v-model="client_order_info.type" :options="type_list"
                             :placeholder="translate('client_order.type')" :clearable="false" :searchable="false" />
              </div>
            </div>

            <div class="col-md-3 col-sm-3">
              <div class="form-group">
                <label> {{ translate('client_order.status') }} </label>
                <tree-select v-model="client_order_info.status" :options="status_list"
                             :placeholder="translate('client_order.status')" :clearable="false" :searchable="false" />
              </div>
            </div>

            <div class="col-md-3 col-sm-3">
            </div>

            <div class="col-md-3 col-sm-3">
              <router-link
                  v-if="client_order_info.client_order_spec_id"
                  :to="'/specification/' + client_order_info.client_order_spec_id"
                  class="link"
              >
                <fg-input v-model="client_order_info.client_order_spec_name" type="text" :label="translate('client_order.specification')"
                          :placeholder="translate('client_order.specification')" :readonly="true"/>
              </router-link>

            </div>
          </div>

          <div class="line row">
            <div class="col-md-6 col-sm-6 text_wrap">
              <div class="form-group">
                <label>{{ translate('client_order.equipment') }}</label>
                <textarea class="input_text" name="equipment" v-model="client_order_info.equipment" :rows="rows_4" />
              </div>
            </div>

            <div class="col-md-6 col-sm-6 text_wrap">
              <div class="form-group">
                <label>{{ translate('client_order.comment') }}</label>
                <textarea class="input_text" name="comment" v-model="client_order_info.descr" :rows="rows_4" />
              </div>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-12 col-sm-12 text_wrap">
              <div class="form-group">
                <label>{{ translate('client_order.address') }}</label>
                <textarea class="input_text" name="address" v-model="client_order_info.address" :rows="rows_3" />
              </div>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-6 col-sm-6">
              <fg-input v-model="client_order_info.track_url" type="text" :label="translate('client_order.track_url')"
                        :placeholder="translate('client_order.track_url')" :readonly="true" />
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="client_order_info.user_name" type="text" :label="translate('client_order.user_who_created_the_order')"
                        :placeholder="translate('client_order.user_who_created_the_order')" :readonly="true" />
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="date_create" type="text" :label="translate('client_order.created')"
                        :placeholder="translate('client_order.created')" :readonly="true" />
            </div>
          </div>
        </div>

        <div class="line text-center buttons__wrap hide_for_print">
          <div class="empty"></div>
          <div class="buttons">
            <span class="btn btn-fill btn-warning btn-wd" @click="download">Download PDF</span>
            <span v-if="has_changes" class="btn btn-success btn-fill btn-wd" @click.prevent="edit_client_order">
              {{ translate('btn.edit') }}
            </span>
          </div>
          <div class="copy">
            <button
                type="button"
                class="btn btn-fill btn-info btn-wd"
                :disabled="copying_simcards"
                @click="copy_order_simcards"
            >
              {{ translate('client_order.copy_simcards') }}
            </button>
            <span
                v-if="!client_order_info.client_order_spec_id"
                class="btn btn-fill btn-info btn-wd"
                @click="pre_copy_client_order"
            >
              {{ translate("btn.copy") }}
            </span>
          </div>


        </div>

        <div ref="info_devices">
          <InfoDevices
              :client_order_info="client_order_info"
              @update="update"
          />
        </div>

        <OrderStatuses
          :client_order_info="client_order_info"
        />
      </div>

    </div>

    <div class="client_order_info__right">
      <Summary type="client_order" :info="client_order_info" :view_history="false" />
    </div>
  </div>

</template>
<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas"

import Summary from "components/UIComponents/Summary/Summary.vue";
import EditDeviceCount from "./Modal/EditDeviceCount.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";
import InfoDevices from "./InfoDevices/InfoDevices.vue";
import OrderStatuses from "./OrderStatuses/OrderStatuses.vue";
import ShowTestConfig from "./Modal/ShowTestConfig.vue";
import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm.vue";

const fields_to_check = ["id", "name", "equipment", "address", "descr", "status", "track_url", "type", "item_cost", "utd_date", "utd_number", "order_form", "device_sku_id", "customer_user_id"];

export default {
  name: 'ClientOrderInfo',
  components: {
    InfoDevices,
    OrderStatuses,
    WrapDatePicker,
    Summary
  },

  props: {
    client_order: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      client_order_info: {},
      copying_simcards: false,
      filter_asc: "asc",
      filter_type: ""
    }
  },

  created() {
    this.client_order_info = JSON.parse(JSON.stringify(this.client_order))
  },

  activated() {
    this.client_order_info = JSON.parse(JSON.stringify(this.client_order))
  },

  computed: {
    company_user_list(){
      return this.$store.getters.getCompanyUserList.map((user) => {
        return {label: user.name, id: user.id}
      })
    },
    rows_4(){
      return this.client_order_info.equipment || this.client_order_info.descr ? '4' : '1'
    },
    rows_3(){
      return this.client_order_info.address ? '3' : '1'
    },
    date_create() {
      return this.get_date(this.client_order.ts_create)
    },

    device_count_status() {
      if (this.client_order_info !== null) {
        return `${this.client_order_info.success_check_device_count} / ${this.client_order_info.device_count}`;
      }
      return '';
    },
    type_list(){
      return this.$store.getters.getClientOrdersInfo.types.map((entry) => {
        return {id: entry.id, label: this.translate("client_order.type_orders." + entry.title)}
      })
    },
    status_list() {
      return this.$store.getters.getClientOrdersInfo.statuses.map((entry) => {
        return {id: entry.id, label: this.translate("client_order.statuses." + entry.title)}
      })
    },
    device_sku_list() {
      return this.$store.getters.getDeviceSkus.map((sku) => {
        return {id: sku.id, label: sku.title}
      })
    },

    has_changes() {
      let main_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.client_order[key];
        return obj;
      }, {});

      let client_order_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.client_order_info[key];
        return obj;
      }, {});

      return JSON.stringify(main_info) !== JSON.stringify(client_order_info);
    }
  },

  watch: {
    client_order(){
      this.client_order_info = Object.assign({}, this.client_order)
    }
  },

  methods: {
    copy_order_simcards(){
      if (this.copying_simcards) return
      this.copying_simcards = true
      try {
        this.$http.v1.getClientOrderSimcards(this.client_order_info.id, (response) => {
          if (!response) return

          const groups = response.data && response.data.simcards
          if (!groups || typeof groups !== 'object' || Array.isArray(groups)
              || !Object.values(groups).every(iccids => Array.isArray(iccids))) {
            this.global_notify('danger', this.translate('client_order.copy_simcards_error'))
            return
          }
          const text = Object.entries(groups)
              .filter(([, iccids]) => iccids.length > 0)
              .map(([operator, iccids]) => `${operator ? operator + ':\n' : ''}${iccids.join('\n')}`)
              .join('\n\n')

          if (!text) {
            this.global_notify('info', this.translate('client_order.no_simcards_for_activation'))
            return
          }

          this.copy_to_clipboard(text)
          this.global_notify('info', this.translate('clipboard.value_save_buffer'))
        })
      } catch (error) {
        this.global_notify('danger', this.translate('client_order.copy_simcards_error'))
      } finally {
        this.copying_simcards = false
      }
    },
    pre_copy_client_order(){
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('client_order.copy_order_confirm')
        },
        on: {
          confirm: () => {
            this.copy_client_order()
            this.$modal.hide('copy_order')
          },
          close: () => {
            this.$modal.hide('copy_order')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'copy_order'})

    },
    copy_client_order(){
      this.$http.v1.copyClientOrder(this.client_order_info.id, (response) => {
        this.global_notify('info', this.translate('client_order.copy_success'))
        this.$router.push({path: '/client_order/' + response.data.id})
      })
    },
    show_test_config(){
      let t = this.$createElement(ShowTestConfig, {
        props: {
          device_sku: this.client_order_info.device_sku,
          data: this.client_order_info.device_sku_test_config
        },
        on: {
          close: () => {
            this.$modal.hide("edit_device_count");
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
          temp,
          {},
          {
            height: "auto",
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: "edit_device_count",
          }
      );
    },
    update(data){
      this.$emit("update", data)
    },
    copy_device_sku(device_sku_id){
      const sku = this.device_sku_list.find(item => {
        if(device_sku_id === item.id){
          return item
        }
      })
      if (sku){
        this.copy_to_clipboard(sku.label);
        this.global_notify("info", this.translate("clipboard.value_save_buffer"));
      }
    },
    edit_device_count(){
      let t = this.$createElement(EditDeviceCount, {
        props: {
          client_order: this.client_order_info
        },
        on: {
          update: (data) => {
            this.$modal.hide("edit_device_count");
            this.$emit("update", data)
          },
          close: () => {
            this.$modal.hide("edit_device_count");
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
          temp,
          {},
          {
            height: "auto",
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: "edit_device_count",
          }
      );
    },
    async download() {
      let info_devices = this.$refs.info_devices
      if (info_devices){
        info_devices.style["fontSize"] = "14px"
        info_devices.style["padding"] = "10px"
        setTimeout(() => {
          info_devices.style["fontSize"] = ""
          info_devices.style["padding"] = ""
        }, 3000);
      }

      let main_info = this.$refs.main_info
      if (main_info){
        main_info.style["padding"] = "10px"
        setTimeout(() => {
          main_info.style["padding"] = ""
        }, 3000);
      }

      let elements = document.getElementsByClassName("hide_for_print")
      for (let element of elements) {
        element.style["display"] = "none"
      }
      setTimeout(() => {
        for (let element of elements) {
          element.style["display"] = ""
        }
      }, 3000);

      let doc = new jsPDF({
        orientation: "l",
        unit: "px",
        format: "a4",
        hotfixes: ["px_scaling"]
      });

      let main_content = this.$refs.content
      let pageHeight = doc.internal.pageSize.getHeight();
      let pdfWidth = doc.internal.pageSize.getWidth();
      let promises = []; // Массив для хранения всех промисов

      let textareas = main_content.querySelectorAll(".input_text");
      let overlays = [];

      textareas.forEach(function(ta) {
        let overlay = document.createElement("div");
        overlay.classList.add("textarea-overlay");
        overlay.innerText = ta.value;
        let computedStyle = window.getComputedStyle(ta);

        overlay.style.whiteSpace = "pre-wrap"; // критично для переноса строк
        overlay.style.width = computedStyle.width;
        overlay.style.height = computedStyle.height;
        overlay.style.font = computedStyle.font;
        overlay.style.padding = computedStyle.padding;
        overlay.style.border = computedStyle.border;
        overlay.style.boxSizing = computedStyle.boxSizing;
        overlay.style.position = "absolute";
        overlay.style.left = ta.offsetLeft + "px";
        overlay.style.top = ta.offsetTop + "px";
        ta.parentElement.appendChild(overlay);
        ta.style.visibility = "hidden";
        overlays.push(overlay);
      });

      if (main_content.offsetHeight > pageHeight){
        let promise1 = await html2canvas(main_info, { scale: 2 }).then(function (main_info_canvas) {
          let img_main_info = main_info_canvas.toDataURL("image/png", 1);
          let imgProps = doc.getImageProperties(img_main_info);
          let pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          doc.addImage(img_main_info, 'PNG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST');
          doc.addPage()
        })
        promises.push(promise1);

        let promise2 = await html2canvas(info_devices, { scale: 2 }).then(function (info_devices_canvas) {
          let img_info_devices = info_devices_canvas.toDataURL("image/png", 1);
          let imgProps = doc.getImageProperties(img_info_devices);
          let pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          doc.addImage(img_info_devices, 'PNG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST');
        })
        promises.push(promise2);
      }else{
        let promise = await html2canvas(main_content, { scale: 2 }).then(function (main_content_canvas) {
          let img_main_content = main_content_canvas.toDataURL("image/png", 1);
          let imgProps = doc.getImageProperties(img_main_content);
          let pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          doc.addImage(img_main_content, 'PNG', 0, 0, pdfWidth, pdfHeight, undefined, 'FAST');
        });
        promises.push(promise);
      }

      Promise.all(promises).then(() => {
        doc.save(`Заказ №${this.client_order_info.id} от ${this.get_date(Math.round(+new Date() / 1000))}.pdf`);
      });

      overlays.forEach(function(overlay) { overlay.remove(); });
      textareas.forEach(function(ta) { ta.style.visibility = "visible"; });
    },

    edit_client_order() {
      let client_order_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.client_order_info[key];
        return obj;
      }, {});

      this.$http.v1.updateClientOrder(this.client_order_info.id, client_order_info, (response) => {
        this.global_notify('info', this.translate('client_order.saved_success'))
        this.client_order_info = response.data
        this.$emit('update', response.data)
      })
    },
  }
}

</script>

<style lang='scss' scoped>
.client_order_info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  @media (max-width: 991px) {
    flex-direction: column;
  }

  &__left {
    width: 70%;
    height: 100%;
    padding-right: 10px;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }

    .form_select{
      .form-control {
        width: 100%;
      }
    }

    .main_info{
      .form-group{
        position: relative;
        margin-bottom: 5px;
      }
      span.edit{
        font-size: 16px;
        &:hover{
          color: #41b883;
        }
      }
    }

    .response_table {
      height: auto;
      padding: 0;
      margin-bottom: 20px;

      .header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        .mdi{
          font-size: 10px;
          padding: 0;
        }
      }



      .status {
        width: 8%;
      }

      .tariffication {
        width: 20%;
      }

      .tariffication_on {
        background-color: #41b88370;
      }

      .tariffication_off {
        background-color: #ff000057;
      }

      .no_tariffication {
        background-color: transparent;
      }

      table {
        tbody {
          .online {
            color: #15ab00;
          }

          span.badge {
            font-size: 12px;
          }

          span {
            font-size: 20px;
          }
        }

        td {
          padding: 5px;
          p{
            margin: 0;
            font-size: 10px;
          }
          &.bad_sku{
            background-color: #ff000057;
          }
        }
      }
      .w70{
        width: 70px;
      }
      .w30{
        width: 30px;
      }
    }

    .rmodems{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      gap: 10px;
      p{
        text-wrap: nowrap;
      }
    }

    .buttons {
      &__wrap{
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: space-between;
        align-items: center;
        .copy{
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }
        .empty{
          width: 140px;
        }
      }

      .btn{
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }

  &__right {
    width: 30%;
    height: 100%;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }
}
</style>
